const dev = {
    firebase: {
        apiKey: "AIzaSyCAwp4VuMRPh1p9-UbdqbX0yQEKyxl7hM8",
        authDomain: "dev-appli-app.firebaseapp.com",
        projectId: "dev-appli-app",
        storageBucket: "dev-appli-app.firebasestorage.app",
        messagingSenderId: "743855311009",
        appId: "1:743855311009:web:80f6397ad3f7e1f32108e0",
    },
    candidateApiUrl: "https://dev-candidates-portal-api.applisolutions.com",
    coreApiUrl: "https://dev-core-api.applisolutions.com",
    marketplaceApiUrl: "https://dev-marketplace-api.applisolutions.com",
    marketplaceUrl: "http://localhost:3000",
    hrApiUrl: "http://localhost:8000",
};

export default dev;
